import React from "react";

function App() {
  return <div>Courting</div>;
}

export default App;
